import {createContext} from "react"
export const LexiconsContext = createContext({
    lexiconsContext: null,
    setLexiconsAction: () => {},
})